import * as React from "react";
import "../styles/tableSection.css";
import HeaderSection from "./HeaderSection";
import TableSection from "./TableSectionPart";
import { AdContext } from "../context/AdContext";

const TableSectionMainPage = () => {
  const { navigateToDashboard, group } = React.useContext(AdContext);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "17px", width: "100%" }}>
      <div className="bt_header_container">
        <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center" }}>
          <div
            onClick={navigateToDashboard}
            className="bt_back_to_list"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
              <path
                d="M5.5 10.9499H13.15C13.508 10.9499 13.8514 10.8077 14.1046 10.5545C14.3578 10.3013 14.5 9.95794 14.5 9.5999V2.3999C14.5 2.04185 14.3578 1.69848 14.1046 1.4453C13.8514 1.19213 13.508 1.0499 13.15 1.0499H5.5L1 5.9999L5.5 10.9499Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Back to List
          </div>
          <section style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
            <div style={{ fontSize: "18px", fontWeight: 700, color: "rgba(100, 103, 107, 1)" }}>
              Group: <span className="bt_heading_name">{group?.displayName}</span>
            </div>
          </section>
        </div>
      </div>
      <HeaderSection />
      <TableSection />
    </div>
  );
};

export default TableSectionMainPage;
